import { createFeatureSelector, createSelector } from '@ngrx/store';
import { podcastAdapter, PodcastState } from './podcast.reducer';
import * as PodcastReducer from './podcast.reducer';

export const getPodcastState = createFeatureSelector<PodcastState>('podcasts');

export const {
  selectAll: getAllPodcasts,
  selectEntities: getPodcastEntities,
  selectIds: getPodcastIds,
  selectTotal: getTotalPodcasts,
} = podcastAdapter.getSelectors(getPodcastState);

export const getSelectedPodcastId = createSelector(
  getPodcastState,
  (state: PodcastState) => state.selectedPodcastId
);

export const getSelectedPodcast = createSelector(
  getPodcastEntities,
  getSelectedPodcastId,
  (entities, id) => (id ? entities[id] : null)
);

export const getCurrentPage = createSelector(
  getPodcastState,
  (state: PodcastState) => state.currentPage
);

export const getTotalPages = createSelector(
  getPodcastState,
  (state: PodcastState) => state.totalPages
);

export const getTotalItems = createSelector(
  getPodcastState,
  (state: PodcastState) => state.totalItems
);

export const getLoading = createSelector(
  getPodcastState,
  (state: PodcastState) => state.loading
);
export const selectAllPodcasts = createSelector(
  getPodcastState,
  PodcastReducer.selectAllPodcasts
);
